function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2864.827,191.657l1.414,1.414-3.829,3.828-2.828-2.828,1.414-1.414,1.414,1.414Zm7.585,5.242h-5v-2h2.784a8.049,8.049,0,0,0-15.567,0h2.783v2h-5a9.619,9.619,0,0,1,6.242-9.326,6,6,0,1,1,7.517,0A9.618,9.618,0,0,1,2872.412,196.9Zm-6-14a4,4,0,1,0-4,4A4,4,0,0,0,2866.412,182.9Z",
  transform: "translate(-2852.412 -176.899)",
  fill: "#fff"
});

var SvgWhiteProfile = function SvgWhiteProfile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhiteProfile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/white-profile.31999c37.svg";
export { ForwardRef as ReactComponent };